import { auth } from '@/service/http';
import { getCookie } from '@/utils/cookies';
import { urlInfo } from '@/utils/url-parse';

export const openTabListGet = async () => {
    try {
        const args = {
            appId: +getCookie('app'),
            depId: +getCookie('dep'),
        };
        const { result, data } = await auth('userdata./userdata/opened-tab/list/get', args);
        return result ? data : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c0dcfd53-ca3b-4be0-8134-e6c6e69f5533',
        };
    }
};
export const openedTabListSet = async args => {
    try {
        args.appId = +getCookie('app');
        args.depId = +getCookie('dep');
        const { result } = await auth('userdata./opened-tab/list/set', args);
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4976af3a-6dfa-4598-b26f-65dd9e36d603',
        };
    }
};
export const getUserDataChanges = async args => {
    try {
        if (!args) {
            args = {};
        }
        const urlData = urlInfo();
        args.appId = urlData.appId;
        args.depId = urlData.depId;
        args.uiRoute = args.uiRoute ? args.uiRoute : window.location.pathname;
        return await auth('userdata./userdata/user-data/get', args);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'e1998c76-54a3-4add-924c-aeb802d9ed6c',
        };
    }
};

export const saveUserDataChanges = async args => {
    try {
        const urlData = urlInfo();
        args.appId = urlData.appId;
        args.depId = urlData.depId;
        args.uiRoute = args.uiRoute ? args.uiRoute : window.location.pathname;
        const { result } = await auth('userdata./userdata/user-data/list/set', args);
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'edd6178e-2063-4dbf-bd14-5ffa97a8363c',
        };
    }
};

export const getUserSettingsChanges = async args => {
    /* {appId, depId, viewId, uiRoute} */
    try {
        args.appId = +getCookie('app');
        args.depId = +getCookie('dep');
        return await auth('userdata./user-settings/list/get', args);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '72653142-b0b3-4c7c-9c9d-b30a25a2563d',
        };
    }
};

export const setUserSettingsChanges = async args => {
    try {
        /*d_view_id character varying := (data->>'viewId');
        d_instance_id integer := (data->>'instanceId');
        d_settings json := (data->'settings');
        d_ui_route character varying := (data->>'uiRoute');*/
        args.appId = +getCookie('app');
        args.depId = +getCookie('dep');
        const { result } = await auth('userdata./user-settings/list/set', args);
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '7664235a-2c28-4d69-aa72-c524a3b78204',
        };
    }
};

export const _loadContexts = async args => {
    try {
        args.appId = +getCookie('app');
        args.depId = +getCookie('dep');
        const loadContextResult = await auth('userdata./load-contexts/list/get', args);
        return loadContextResult;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '96869bb9-29e0-4b73-8c71-7d4bfbf2ae07',
        };
    }
};
export const _saveContexts = async args => {
    try {
        args.appId = +getCookie('app');
        args.depId = +getCookie('dep');
        const contextGroups = await _loadContexts(args);
        const newValue = { ...contextGroups.changes };
        newValue[args.nameGroup] = args.value;
        console.log('contextGroups', newValue);
        args.changes = newValue;
        const saveContextsResult = await auth('userdata./save-contexts/list/set', args);
        return { result: saveContextsResult.result, changes: newValue };
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '78269bde-2092-41f4-8ebe-090d2f25a8a3',
        };
    }
};

export const deleteUserDataChanges = async args => {
    try {
        const urlData = urlInfo();
        args.appId = urlData.appId;
        args.depId = urlData.depId;
        args.uiRoute ? args.uiRoute : (args.uiRoute = window.location.pathname);
        const { result } = await auth('userdata./user-data/delete', args);
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '900153aa-6e66-4d3b-b571-ffbb8274b2ee',
        };
    }
};

export const deleteUserSettingsChanges = async args => {
    try {
        args.appId = +getCookie('app');
        args.depId = +getCookie('dep');
        const { result } = await auth('userdata./user-settings/delete', args);
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5475d345-ca54-4faf-9f66-b5633e689515',
        };
    }
};
